"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeefoWidget = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const HtmlInclude_1 = require("../components/common/html-include/HtmlInclude");
const ScriptLoaderUtil_1 = tslib_1.__importDefault(require("../util/ScriptLoaderUtil"));
const react_1 = require("react");
const useFeefoWidget = (productCode, shouldLoad) => {
    const { review: { feefoIdentifier }, } = (0, common_components_1.useAemConfig)();
    const loadFeefoWidget = (feefoIdentifier) => {
        ScriptLoaderUtil_1.default.loadScript(`https://api.feefo.com/feefo-widgets-data/loader/widgets/${feefoIdentifier}`, `feefo-widget-${feefoIdentifier}`);
    };
    const renderFeefoWidget = () => ((0, jsx_runtime_1.jsx)(HtmlInclude_1.HtmlInclude, { htmlFragment: `<feefo-product-reviews sku="${productCode}" version="20" />` }));
    (0, react_1.useEffect)(() => {
        if (shouldLoad && feefoIdentifier) {
            loadFeefoWidget(feefoIdentifier);
        }
    }, [shouldLoad]);
    return {
        renderFeefoWidget,
    };
};
exports.useFeefoWidget = useFeefoWidget;
